import { useState } from 'react';
import { Dropdown } from 'antd';

import Settings04Icon from 'assets/svg/Settings04Icon';

import ColumnFilterSortPanel, { type ColumnFilterSortValue } from './ColumnFilterSortPanel';

type ColumnFilterSortHeaderProps = {
    title: string;
    options: string[];
    value: ColumnFilterSortValue;
    onApply: (value: ColumnFilterSortValue) => void;
};

const FILTER_SORT_DROPDOWN_OVERLAY_STYLE = {
    padding: 0,
    background: 'transparent',
    boxShadow: 'none',
};

const ColumnFilterSortHeader = ({ title, options, value, onApply }: ColumnFilterSortHeaderProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleCancel = () => {
        setIsOpen(false);
    };

    const handleApply = (nextValue: ColumnFilterSortValue) => {
        onApply(nextValue);
        setIsOpen(false);
    };

    return (
        <div className="flex w-full items-center justify-between gap-2">
            <span className="truncate text-left text-[12px] font-semibold leading-[18px]">{title}</span>
            <Dropdown
                trigger={['click']}
                open={isOpen}
                onOpenChange={setIsOpen}
                placement="bottomRight"
                overlayClassName="column-filter-sort-dropdown"
                overlayStyle={FILTER_SORT_DROPDOWN_OVERLAY_STYLE}
                destroyPopupOnHide
                getPopupContainer={() => document.body}
                dropdownRender={() => (
                    <ColumnFilterSortPanel options={options} value={value} onCancel={handleCancel} onApply={handleApply} />
                )}
            >
                <button
                    type="button"
                    className={`column-filter-sort-trigger inline-flex size-5 shrink-0 items-center justify-center rounded-[4px]${
                        isOpen ? ' is-open' : ''
                    }${value.sortOrder ? ' is-sorted' : ''}`}
                    aria-label={`Filter and sort ${title}`}
                    onClick={(event) => event.stopPropagation()}
                >
                    <Settings04Icon />
                </button>
            </Dropdown>
        </div>
    );
};

export default ColumnFilterSortHeader;
